import { Routes, Route, Navigate } from "react-router-dom";


import ColdChains from "./ColdChains";

const coldChainsRoutes = [
    // {routeName: 'temperature-control-transportations' , component: <ColdChains/>},
    // {routeName: 'storage' , component: <ColdChains/>},
    // {routeName: 'distribution' , component: <ColdChains/>},
    // {routeName: 'ltl-services' , component: <ColdChains/>},
    
               
];

const ColdChainsRoutes = () => {
    return (
    <Routes>
       {coldChainsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default ColdChainsRoutes;